module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customerOpinions"
    }
  }, [_c('div', {
    staticClass: "top-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "assets/images/customerOpinions/customerOpinionsIcon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "section-title blue"
  }, [_vm._v(_vm._s(_vm.t('title')))]), _vm._v(" "), _c('div', {
    staticClass: "en-customers"
  }, _vm._l((_vm.customers), function(row, i) {
    return _c('div', {
      staticClass: "en-customers-row"
    }, _vm._l((row), function(customer, j) {
      return _c('div', {
        staticClass: "en-customer",
        class: {
          'active': customer.isActive, 'non-customer': customer.more
        }
      }, [(customer.more) ? [_vm._m(0, true)] : [_c('img', {
        attrs: {
          "src": customer.graySRC,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "en-customer-opinion"
      }, [_c('img', {
        attrs: {
          "src": customer.coloredSRC,
          "alt": ""
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "opinion-text"
      }, [_vm._v(_vm._s(customer.opinion))])])]], 2)
    }))
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mock-customer"
  }, [_c('i', {
    staticClass: "en en-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cbc8e3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/CustomerOpinions.vue
// module id = 412
// module chunks = 3